export interface IOrderProducts {
  id?: number;
  cityId?: number | null;
  name?: string;
  offer?: number | null;
  image?: string;
  categoryId?: number | null;
  pincode?: number | null;
  description?: string | null;
  count?: number;
  price?: number;
  quantity?: number;
  unit?: string;
  discount?: number | null;
  orderId?: string;
}

export const defaultValue: Readonly<IOrderProducts> = {};
